import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from 'src/models/ladder.model';
import { Level } from 'src/models/level.model';
import { Score } from 'src/models/score.model';

@Component({
  selector: 'admin-record',
  templateUrl: './record.component.html',
})
export class AdminRecordComponent implements OnInit {
  public pairingForm: FormGroup;
  public result: string;
  public ladders: Ladder[] = [];
  public levels: Level[] = [];

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.pairingForm = fb.group({
      ladderId: new FormControl(''),
      levelId: new FormControl(1),
    });
    //this.pairingForm.controls.ladderId.valueChanges.subscribe(
    //  (newVal) => {
    //    this.getPlayers(newVal, this.pairingForm.value.levelId);
    //  }
    //);
    //this.pairingForm.controls.levelId.valueChanges.subscribe(
    //  (newVal) => {
    //    this.getPlayers(this.pairingForm.value.ladderId, newVal);
    //  }
    //);
  }




  //get players(): FormArray {
  //  return this.pairingForm.get("players") as FormArray
  //}
  ngOnInit() {
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
    this.http.get<Level[]>('/levels').subscribe(
      (resp) => {
        this.levels.length = 0;
        for (const l of resp) {
          this.levels.push(new Level(l));
        }
      }
    )
  }

  public doit(evt) {
  }

}
